import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import {
  IconButton,
  Icon,
} from 'components';
import styles from './CommentTrigger.scss';

const CommentTrigger = ({
  className,
  open,
  isOpen,
  numberOfComments,
  questionId
}) =>
  <IconButton
    id={questionId}
    data-testid={`comments-popOver-trigger__question-${questionId}`}
    onClick={open}
    className={classnames(className, styles.commentIcon, {
      [styles.hasComments]: numberOfComments > 0,
      [styles.isOpen]: isOpen,
    })}
    disableRipple
  >
    {
      numberOfComments > 0 &&
      <span className={styles.numberComments}>
        {numberOfComments <= 9 ? numberOfComments : '9+'}
      </span>
    }
    <Icon name='ion-md-chatboxes'/>
  </IconButton>;

CommentTrigger.propTypes = {
  className: PropTypes.string,
  open: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
  numberOfComments: PropTypes.number.isRequired,
  questionId: PropTypes.string.isRequired,
};

export default CommentTrigger;
